// extracted by mini-css-extract-plugin
export default {"zrb":"index_zrb_33vub","footer":"index_footer_ls9qy","commomAd":"index_commomAd_9oBSd"};